import React from 'react';
import MinigameCenter from '../../components/Minigame/MinigameCenter';
import SportsRight from '../../components/sports/SportsRight';

const Soccer = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <MinigameCenter type="soccer"/>
            <SportsRight type="minigame"/>
        </div>
    );
};

export default Soccer;


// WEBPACK FOOTER //
// ./src/containers/minigame/Soccer.js